import { useRxDBContext } from "$global-providers/rxdb-provider/provider";

type PatientHistoryReplicationState = {
  isPulling: boolean;
  failedToPull: boolean;
  lastPulledAt: Date | null;
};

export const usePatientHistoryReplicationState =
  (): PatientHistoryReplicationState => {
    const {
      replicationState: {
        consultation,
        prescription,
        dispensation,
        investigationActivity,
        imagingStudy,
        imagingInstance,
        referral,
        "referral-feedback": referralFeedback,
      },
    } = useRxDBContext();

    const isPulling =
      consultation.isPulling ||
      prescription.isPulling ||
      dispensation.isPulling ||
      investigationActivity.isPulling ||
      imagingStudy.isPulling ||
      imagingInstance.isPulling ||
      referral.isPulling ||
      referralFeedback.isPulling;

    const failedToPull =
      consultation.failedToPull ||
      prescription.failedToPull ||
      dispensation.failedToPull ||
      investigationActivity.failedToPull ||
      imagingStudy.failedToPull ||
      imagingInstance.failedToPull ||
      referral.failedToPull ||
      referralFeedback.failedToPull;

    const lastPulledAtDates = [
      consultation.lastPulledAt,
      prescription.lastPulledAt,
      dispensation.lastPulledAt,
      investigationActivity.lastPulledAt,
      imagingStudy.lastPulledAt,
      imagingInstance.lastPulledAt,
      referral.lastPulledAt,
      referralFeedback.lastPulledAt,
    ]
      .filter(Boolean)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

    const lastPulledAt =
      lastPulledAtDates.length > 0 ? lastPulledAtDates[0] : null;

    return {
      isPulling,
      failedToPull,
      lastPulledAt,
    };
  };
